// A single label/value row, the web equivalent of the app's DataItem. Read-only
// and purely presentational. An empty value renders a muted em dash so a missing
// diagnostic reads as "not reported" rather than a blank gap.
export default function DataItem({ title, value }) {
  const empty = value === undefined || value === null || value === '';
  return (
    <div className="data-item">
      <span className="data-item__label">{title}</span>
      <span
        className={`data-item__value${empty ? ' data-item__value--empty' : ''}`}
      >
        {empty ? '—' : value}
      </span>
    </div>
  );
}
